(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const shopDogLink = document.getElementById('shopDogLink');
  const shopMegaMenu = document.getElementById('shopMegaMenu');
  const learnLink = document.getElementById('learnLink');
  const learnMegaMenu = document.getElementById('learnMegaMenu');

  const kibblesCategory = document.getElementById('kibblesCategory');
  const kibblesContent = document.getElementById('kibblesContent');
  const treatsCategory = document.getElementById('treatsCategory');
  const treatsContent = document.getElementById('treatsContent');
  const toppersCategory = document.getElementById('toppersCategory');
  const toppersContent = document.getElementById('toppersContent');
  const bundlesCategory = document.getElementById('bundlesCategory');
  const bundlesContent = document.getElementById('bundlesContent');
  // const merchandiseCategory = document.getElementById('merchandiseCategory');
  // const merchandiseContent = document.getElementById('merchandiseContent');
  const catKibblesCategory = document.getElementById('catKibblesCategory');
  const catKibblesContent = document.getElementById('catKibblesContent');
  const catCansCategory = document.getElementById('catCansCategory');
  const catCansContent = document.getElementById('catCansContent');
  const catToppersCategory = document.getElementById('catToppersCategory');
  const catToppersContent = document.getElementById('catToppersContent');
  const catTreatsCategory = document.getElementById('catTreatsCategory');
  const catTreatsContent = document.getElementById('catTreatsContent');
  const catBundlesCategory = document.getElementById('catBundlesCategory');
  const catBundlesContent = document.getElementById('catBundlesContent');

  kibblesCategory.addEventListener('mouseenter', () => {
    kibblesContent.classList.remove('hidden');
    kibblesContent.classList.add('grid');
    treatsContent.classList.add('hidden');
    treatsContent.classList.remove('grid');
    toppersContent.classList.add('hidden');
    toppersContent.classList.remove('grid');
    bundlesContent.classList.add('hidden');
    bundlesContent.classList.remove('grid');
    // merchandiseContent.classList.add('hidden');
    // merchandiseContent.classList.remove('grid');
  });

  treatsCategory.addEventListener('mouseenter', () => {
    treatsContent.classList.remove('hidden');
    treatsContent.classList.add('grid');
    kibblesContent.classList.add('hidden');
    kibblesContent.classList.remove('grid');
    toppersContent.classList.add('hidden');
    toppersContent.classList.remove('grid');
    bundlesContent.classList.add('hidden');
    bundlesContent.classList.remove('grid');
    // merchandiseContent.classList.add('hidden');
    // merchandiseContent.classList.remove('grid');
  });

  toppersCategory.addEventListener('mouseenter', () => {
    toppersContent.classList.remove('hidden');
    toppersContent.classList.add('grid');
    kibblesContent.classList.add('hidden');
    kibblesContent.classList.remove('grid');
    treatsContent.classList.add('hidden');
    treatsContent.classList.remove('grid');
    bundlesContent.classList.add('hidden');
    bundlesContent.classList.remove('grid');
  });
  bundlesCategory.addEventListener('mouseenter', () => {
    toppersContent.classList.remove('grid');
    toppersContent.classList.add('hidden');
    kibblesContent.classList.add('hidden');
    kibblesContent.classList.remove('grid');
    treatsContent.classList.add('hidden');
    treatsContent.classList.remove('grid');
    bundlesContent.classList.add('grid');
    bundlesContent.classList.remove('hidden');
  });

  // merchandiseCategory.addEventListener('mouseenter', () => {
  //   merchandiseContent.classList.remove('hidden');
  //   merchandiseContent.classList.add('grid');
  //   kibblesContent.classList.add('hidden');
  //   kibblesContent.classList.remove('grid');
  //   treatsContent.classList.add('hidden');
  //   treatsContent.classList.remove('grid');
  // });

  catKibblesCategory.addEventListener('mouseenter', () => {
    catKibblesContent.classList.remove('hidden');
    catKibblesContent.classList.add('grid');
    catCansContent.classList.add('hidden');
    catCansContent.classList.remove('grid');
    catToppersContent.classList.add('hidden');
    catToppersContent.classList.remove('grid');
    catTreatsContent.classList.add('hidden');
    catTreatsContent.classList.remove('grid');
    catBundlesContent.classList.add('hidden');
    catBundlesContent.classList.remove('grid');
  });
  catCansCategory.addEventListener('mouseenter', () => {
    catCansContent.classList.remove('hidden');
    catCansContent.classList.add('grid');
    catKibblesContent.classList.add('hidden');
    catKibblesContent.classList.remove('grid');
    catToppersContent.classList.add('hidden');
    catToppersContent.classList.remove('grid');
    catTreatsContent.classList.add('hidden');
    catTreatsContent.classList.remove('grid');
    catBundlesContent.classList.add('hidden');
    catBundlesContent.classList.remove('grid');
  });
  catToppersCategory.addEventListener('mouseenter', () => {
    catToppersContent.classList.remove('hidden');
    catToppersContent.classList.add('grid');
    catKibblesContent.classList.add('hidden');
    catKibblesContent.classList.remove('grid');
    catCansContent.classList.add('hidden');
    catCansContent.classList.remove('grid');
    catTreatsContent.classList.add('hidden');
    catTreatsContent.classList.remove('grid');
    catBundlesContent.classList.add('hidden');
    catBundlesContent.classList.remove('grid');
  });
  catTreatsCategory.addEventListener('mouseenter', () => {
    catTreatsContent.classList.remove('hidden');
    catTreatsContent.classList.add('grid');
    catKibblesContent.classList.add('hidden');
    catKibblesContent.classList.remove('grid');
    catCansContent.classList.add('hidden');
    catCansContent.classList.remove('grid');
    catToppersContent.classList.add('hidden');
    catToppersContent.classList.remove('grid');
    catBundlesContent.classList.add('hidden');
    catBundlesContent.classList.remove('grid');
  });
  catBundlesCategory.addEventListener('mouseenter', () => {
    catBundlesContent.classList.remove('hidden');
    catBundlesContent.classList.add('grid');
    catKibblesContent.classList.add('hidden');
    catKibblesContent.classList.remove('grid');
    catCansContent.classList.add('hidden');
    catCansContent.classList.remove('grid');
    catToppersContent.classList.add('hidden');
    catToppersContent.classList.remove('grid');
    catTreatsContent.classList.add('hidden');
    catTreatsContent.classList.remove('grid');
  });

  const shopDogMobileDropdownBtn = document.getElementById('shopDogMobileDropdownBtn');
  const shopCatMobileDropdownBtn = document.getElementById('shopCatMobileDropdownBtn');
  const shopCatArrow = document.getElementById('shopCatArrow');
  const learnMobileDropdownBtn = document.getElementById('learnMobileDropdownBtn');
  const shopDogMobileDropdown = document.getElementById('shopDogMobileDropdown');
  const shopCatMobileDropdown = document.getElementById('shopCatMobileDropdown');
  const learnMobileDropdown = document.getElementById('learnMobileDropdown');
  const shopArrow = document.getElementById('shopArrow');
  const learnArrow = document.getElementById('learnArrow');

  shopDogMobileDropdownBtn.addEventListener('click', () => {
    shopArrow.classList.toggle('rotate-180');
    shopDogMobileDropdown.classList.toggle('hidden');
    shopDogMobileDropdown.classList.toggle('grid');
  });
  shopCatMobileDropdownBtn.addEventListener('click', () => {
    shopCatArrow.classList.toggle('rotate-180');
    shopCatMobileDropdown.classList.toggle('hidden');
    shopCatMobileDropdown.classList.toggle('grid');
  });
  learnMobileDropdownBtn.addEventListener('click', () => {
    learnArrow.classList.toggle('rotate-180');
    learnMobileDropdown.classList.toggle('hidden');
    learnMobileDropdown.classList.toggle('flex');
  });

  const mobileMenuButton = document.getElementById('mobileMenuButton');
  const mobileDropdown = document.getElementById('mobileDropdown');
  const mobileDropdownOverlay = document.getElementById('mobileDropdownOverlay');

  mobileMenuButton.addEventListener('click', () => {
    mobileDropdown.classList.toggle('hidden');
  });

  mobileDropdownOverlay.addEventListener('click', () => {
    mobileDropdown.classList.toggle('hidden');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiperHero = new Swiper('.swiper-hero', {
      loop: true,
      autoplay: { delay: 4000, disableOnInteraction: false },
      slidesPerView: 1,
    });

    const favTabs = document.querySelectorAll('.btn-fav-tab');
    favTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        // Remove active class from all tabs
        const spanClicked = tab.querySelector('.span-fav-tab');

        favTabs.forEach(function (t) {
          const span = t.querySelector('.span-fav-tab');
          span.classList.remove('span-fav-tab-active');
        });
        // Add active class to the clicked tab
        spanClicked.classList.add('span-fav-tab-active');
      });
    });

    const swiperFavDog = new Swiper('.swiper-fav-dog', {
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 16 },
      },
    });

    const swiperFavCat = new Swiper('.swiper-fav-cat', {
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 16 },
      },
    });

    const swiperPartneringShelters = new Swiper('.swiper-partnering-shelters', {
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 3, spaceBetween: 24 },
        1024: { slidesPerView: 7, spaceBetween: 40 },
      },
    });

    const btnFavDog = document.getElementById('btn-fav-dog');
    const btnFavCat = document.getElementById('btn-fav-cat');
    const tabFavDog = document.getElementById('tab-fav-dog');
    const tabFavCat = document.getElementById('tab-fav-cat');

    btnFavDog.addEventListener('click', function () {
      tabFavDog.classList.remove('hidden');
      tabFavCat.classList.add('hidden');
    });

    btnFavCat.addEventListener('click', function () {
      tabFavDog.classList.add('hidden');
      tabFavCat.classList.remove('hidden');
    });

    function setAccordionIconState(icon, isExpanded) {
      if (!icon) return;
      if (icon.classList.contains('faq-accordion-symbol')) {
        icon.textContent = isExpanded ? '\u2212' : '+';
        return;
      }
      icon.classList.toggle('rotate-180', isExpanded);
    }

    const accordionButtons = document.querySelectorAll('.accordion-button');
    accordionButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        console.log('btn clicked');
        const targetSelector = btn.getAttribute('data-accordion-target');
        const content = targetSelector ? document.querySelector(targetSelector) : null;
        if (!content) return;

        const root = btn.closest('.accordion');
        if (!root) return;

        const expanded = btn.getAttribute('aria-expanded') === 'true';

        root.querySelectorAll('.accordion-collapse').forEach((panel) => {
          panel.classList.add('hidden');
        });
        root.querySelectorAll('.accordion-button').forEach((otherBtn) => {
          otherBtn.setAttribute('aria-expanded', 'false');
          setAccordionIconState(otherBtn.querySelector('.accordion-icon'), false);
        });

        if (!expanded) {
          content.classList.remove('hidden');
          btn.setAttribute('aria-expanded', 'true');
          setAccordionIconState(btn.querySelector('.accordion-icon'), true);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection"]) return;
  try {
    
  const sortBy = document.getElementById('sort-by');
  sortBy.addEventListener('change', function () {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-nutrition"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.swiper-raw-ingredients', {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      breakpoints: {
        320: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 16 },
        1024: { slidesPerView: 5, spaceBetween: 16 },
      },
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true,
      },
    });

    const favTabs = document.querySelectorAll('.btn-kibbles-tab');
    favTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        // Remove active class from all tabs
        const spanClicked = tab.querySelector('.span-kibbles-tab');

        favTabs.forEach(function (t) {
          const span = t.querySelector('.span-kibbles-tab');
          span.classList.remove('span-kibbles-tab-active');
        });
        // Add active class to the clicked tab
        spanClicked.classList.add('span-kibbles-tab-active');
      });
    });

    const btnDogKibbleBowls = document.getElementById('btn-dog-kibble-bowls');
    const btnCatKibbleBowls = document.getElementById('btn-cat-kibble-bowls');
    const tabDogKibbleBowls = document.getElementById('dog-kibble-bowls');
    const tabCatKibbleBowls = document.getElementById('cat-kibble-bowls');

    btnDogKibbleBowls.addEventListener('click', function () {
      tabDogKibbleBowls.classList.remove('hidden');
      if (tabCatKibbleBowls) tabCatKibbleBowls.classList.add('hidden');
    });

    btnCatKibbleBowls.addEventListener('click', function () {
      tabDogKibbleBowls.classList.add('hidden');
      tabCatKibbleBowls.classList.remove('hidden');
    });

    const swiperDogKibbleBowls = new Swiper('.swiper-dog-kibble-bowls', {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 16 },
        1024: { slidesPerView: 5, spaceBetween: 16 },
      },
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true,
      },
    });
    const swiperCatKibbleBowls = new Swiper('.swiper-cat-kibble-bowls', {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 16 },
      },
    });
    const swiperFavDog = new Swiper('.swiper-fav-dog', {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 16 },
      },
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true,
      },
    });
    const swiperBenefitsMobile = new Swiper('.swiper-benefits-mobile', {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-cat-cans-new"]) return;
  try {
    
  const productImages = document.querySelectorAll('[data-target-index]');
  let currentImage = document.getElementById('product-image-0');

  // productImages.forEach((image) => {
  //   image.addEventListener('click', () => {
  //     const targetIndex = image.getAttribute('data-target-index');
  //     const targetImage = document.querySelector(targetIndex);
  //     currentImage.classList.add('hidden');
  //     targetImage.classList.remove('hidden');
  //     currentImage = targetImage;
  //   });
  // });

  const productAccordion = document.querySelectorAll('[data-product-accordion-target]');
  productAccordion.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      const targetContent = accordion.getAttribute('data-product-accordion-target');
      const targetContentElement = document.querySelector(targetContent);
      if (targetContentElement.classList.contains('hidden')) {
        targetContentElement.classList.remove('hidden');
        targetContentElement.classList.add('flex');
      } else {
        targetContentElement.classList.add('hidden');
        targetContentElement.classList.remove('flex');
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const swiperProductImagesSelector = new Swiper('.swiper-product-images-selector', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 5, direction: 'horizontal', spaceBetween: 2 },
        768: { slidesPerView: 5, direction: 'vertical', spaceBetween: 4 },
      },
    });
    const swiperProductImagesDisplay = new Swiper('.swiper-product-images-display', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      thumbs: {
        swiper: swiperProductImagesSelector,
      },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
      },
      updateOnWindowResize: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
    });
    requestAnimationFrame(() => {
      swiperProductImagesDisplay.update();
    });

    // const swiperFavDog = new Swiper('.swiper-fav-dog', {
    //   loop: true,
    //   autoplay: { delay: 2500, disableOnInteraction: false },
    //   slidesPerView: 1,
    //   spaceBetween: 16,
    //   breakpoints: {
    //     320: { slidesPerView: 1, spaceBetween: 16 },
    //     1024: { slidesPerView: 3, spaceBetween: 16 },
    //   },
    // });
    const swiperVetRecommendations = new Swiper('.swiper-vet-recommendations', {
      loop: true,
      // autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: { el: '.swiper-pagination-vet-recommendations', clickable: true },
    });

    const refreshKlaviyoCarouselSwiper = () => {
      const klaviyoRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
      if (!klaviyoRoot) return;

      const klaviyoSwipers = klaviyoRoot.querySelectorAll('.swiper');
      klaviyoSwipers.forEach((swiperElement) => {
        if (swiperElement.swiper) {
          swiperElement.swiper.update();
          swiperElement.swiper.updateSize();
          swiperElement.swiper.updateSlides();
        }
      });
    };

    const klaviyoCarouselRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
    if (klaviyoCarouselRoot) {
      const klaviyoCarouselObserver = new MutationObserver(() => {
        refreshKlaviyoCarouselSwiper();
      });

      klaviyoCarouselObserver.observe(klaviyoCarouselRoot, {
        childList: true,
        subtree: true,
      });

      window.addEventListener('resize', refreshKlaviyoCarouselSwiper);
      window.addEventListener('orientationchange', refreshKlaviyoCarouselSwiper);
      setTimeout(refreshKlaviyoCarouselSwiper, 300);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-cat-kibbles-new"]) return;
  try {
    
  const productImages = document.querySelectorAll('[data-target-index]');
  let currentImage = document.getElementById('product-image-0');

  productImages.forEach((image) => {
    image.addEventListener('click', () => {
      const targetIndex = image.getAttribute('data-target-index');
      const targetImage = document.querySelector(targetIndex);
      currentImage.classList.add('hidden');
      targetImage.classList.remove('hidden');
      currentImage = targetImage;
    });
  });

  const productAccordion = document.querySelectorAll('[data-product-accordion-target]');
  productAccordion.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      const targetContent = accordion.getAttribute('data-product-accordion-target');
      const targetContentElement = document.querySelector(targetContent);
      if (targetContentElement.classList.contains('hidden')) {
        targetContentElement.classList.remove('hidden');
        targetContentElement.classList.add('flex');
      } else {
        targetContentElement.classList.add('hidden');
        targetContentElement.classList.remove('flex');
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const swiperProductImagesSelector = new Swiper('.swiper-product-images-selector', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 5, direction: 'horizontal', spaceBetween: 2 },
        768: { slidesPerView: 5, direction: 'vertical', spaceBetween: 4 },
      },
    });
    const swiperProductImagesDisplay = new Swiper('.swiper-product-images-display', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      thumbs: {
        swiper: swiperProductImagesSelector,
      },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
      },
      updateOnWindowResize: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
    });
    requestAnimationFrame(() => {
      swiperProductImagesDisplay.update();
    });

    const swiperFavDog = new Swiper('.swiper-fav-dog', {
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 16 },
      },
    });
    const swiperVetRecommendations = new Swiper('.swiper-vet-recommendations', {
      loop: true,
      // autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: { el: '.swiper-pagination-vet-recommendations', clickable: true },
    });

    const refreshKlaviyoCarouselSwiper = () => {
      const klaviyoRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
      if (!klaviyoRoot) return;

      const klaviyoSwipers = klaviyoRoot.querySelectorAll('.swiper');
      klaviyoSwipers.forEach((swiperElement) => {
        if (swiperElement.swiper) {
          swiperElement.swiper.update();
          swiperElement.swiper.updateSize();
          swiperElement.swiper.updateSlides();
        }
      });
    };

    const klaviyoCarouselRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
    if (klaviyoCarouselRoot) {
      const klaviyoCarouselObserver = new MutationObserver(() => {
        refreshKlaviyoCarouselSwiper();
      });

      klaviyoCarouselObserver.observe(klaviyoCarouselRoot, {
        childList: true,
        subtree: true,
      });

      window.addEventListener('resize', refreshKlaviyoCarouselSwiper);
      window.addEventListener('orientationchange', refreshKlaviyoCarouselSwiper);
      setTimeout(refreshKlaviyoCarouselSwiper, 300);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-cat-toppers-new"]) return;
  try {
    
  const productImages = document.querySelectorAll('[data-target-index]');
  let currentImage = document.getElementById('product-image-0');

  productImages.forEach((image) => {
    image.addEventListener('click', () => {
      const targetIndex = image.getAttribute('data-target-index');
      const targetImage = document.querySelector(targetIndex);
      currentImage.classList.add('hidden');
      targetImage.classList.remove('hidden');
      currentImage = targetImage;
    });
  });

  const productAccordion = document.querySelectorAll('[data-product-accordion-target]');
  productAccordion.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      const targetContent = accordion.getAttribute('data-product-accordion-target');
      const targetContentElement = document.querySelector(targetContent);
      if (targetContentElement.classList.contains('hidden')) {
        targetContentElement.classList.remove('hidden');
        targetContentElement.classList.add('flex');
      } else {
        targetContentElement.classList.add('hidden');
        targetContentElement.classList.remove('flex');
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const swiperProductImagesSelector = new Swiper('.swiper-product-images-selector', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 5, direction: 'horizontal', spaceBetween: 2 },
        768: { slidesPerView: 5, direction: 'vertical', spaceBetween: 4 },
      },
    });
    const swiperProductImagesDisplay = new Swiper('.swiper-product-images-display', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      thumbs: {
        swiper: swiperProductImagesSelector,
      },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
      },
      updateOnWindowResize: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
    });
    requestAnimationFrame(() => {
      swiperProductImagesDisplay.update();
    });

    const swiperFavDog = new Swiper('.swiper-fav-dog', {
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 16 },
      },
    });
    const swiperVetRecommendations = new Swiper('.swiper-vet-recommendations', {
      loop: true,
      // autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: { el: '.swiper-pagination-vet-recommendations', clickable: true },
    });

    const refreshKlaviyoCarouselSwiper = () => {
      const klaviyoRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
      if (!klaviyoRoot) return;

      const klaviyoSwipers = klaviyoRoot.querySelectorAll('.swiper');
      klaviyoSwipers.forEach((swiperElement) => {
        if (swiperElement.swiper) {
          swiperElement.swiper.update();
          swiperElement.swiper.updateSize();
          swiperElement.swiper.updateSlides();
        }
      });
    };

    const klaviyoCarouselRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
    if (klaviyoCarouselRoot) {
      const klaviyoCarouselObserver = new MutationObserver(() => {
        refreshKlaviyoCarouselSwiper();
      });

      klaviyoCarouselObserver.observe(klaviyoCarouselRoot, {
        childList: true,
        subtree: true,
      });

      window.addEventListener('resize', refreshKlaviyoCarouselSwiper);
      window.addEventListener('orientationchange', refreshKlaviyoCarouselSwiper);
      setTimeout(refreshKlaviyoCarouselSwiper, 300);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-cat-treats-new"]) return;
  try {
    
  const productImages = document.querySelectorAll('[data-target-index]');
  let currentImage = document.getElementById('product-image-0');

  productImages.forEach((image) => {
    image.addEventListener('click', () => {
      const targetIndex = image.getAttribute('data-target-index');
      const targetImage = document.querySelector(targetIndex);
      currentImage.classList.add('hidden');
      targetImage.classList.remove('hidden');
      currentImage = targetImage;
    });
  });

  const productAccordion = document.querySelectorAll('[data-product-accordion-target]');
  productAccordion.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      const targetContent = accordion.getAttribute('data-product-accordion-target');
      const targetContentElement = document.querySelector(targetContent);
      if (targetContentElement.classList.contains('hidden')) {
        targetContentElement.classList.remove('hidden');
        targetContentElement.classList.add('flex');
      } else {
        targetContentElement.classList.add('hidden');
        targetContentElement.classList.remove('flex');
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const swiperProductImagesSelector = new Swiper('.swiper-product-images-selector', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 5, direction: 'horizontal', spaceBetween: 2 },
        768: { slidesPerView: 5, direction: 'vertical', spaceBetween: 4 },
      },
    });
    const swiperProductImagesDisplay = new Swiper('.swiper-product-images-display', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      thumbs: {
        swiper: swiperProductImagesSelector,
      },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
      },
      updateOnWindowResize: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
    });
    requestAnimationFrame(() => {
      swiperProductImagesDisplay.update();
    });

    const swiperFavDog = new Swiper('.swiper-fav-dog', {
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 16 },
      },
    });
    const swiperVetRecommendations = new Swiper('.swiper-vet-recommendations', {
      loop: true,
      // autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: { el: '.swiper-pagination-vet-recommendations', clickable: true },
    });

    const refreshKlaviyoCarouselSwiper = () => {
      const klaviyoRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
      if (!klaviyoRoot) return;

      const klaviyoSwipers = klaviyoRoot.querySelectorAll('.swiper');
      klaviyoSwipers.forEach((swiperElement) => {
        if (swiperElement.swiper) {
          swiperElement.swiper.update();
          swiperElement.swiper.updateSize();
          swiperElement.swiper.updateSlides();
        }
      });
    };

    const klaviyoCarouselRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
    if (klaviyoCarouselRoot) {
      const klaviyoCarouselObserver = new MutationObserver(() => {
        refreshKlaviyoCarouselSwiper();
      });

      klaviyoCarouselObserver.observe(klaviyoCarouselRoot, {
        childList: true,
        subtree: true,
      });

      window.addEventListener('resize', refreshKlaviyoCarouselSwiper);
      window.addEventListener('orientationchange', refreshKlaviyoCarouselSwiper);
      setTimeout(refreshKlaviyoCarouselSwiper, 300);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-dog-kibbles-new"]) return;
  try {
    
  const productImages = document.querySelectorAll('[data-target-index]');
  let currentImage = document.getElementById('product-image-0');

  productImages.forEach((image) => {
    image.addEventListener('click', () => {
      const targetIndex = image.getAttribute('data-target-index');
      const targetImage = document.querySelector(targetIndex);
      currentImage.classList.add('hidden');
      targetImage.classList.remove('hidden');
      currentImage = targetImage;
    });
  });

  const productAccordion = document.querySelectorAll('[data-product-accordion-target]');
  productAccordion.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      const targetContent = accordion.getAttribute('data-product-accordion-target');
      const targetContentElement = document.querySelector(targetContent);
      if (targetContentElement.classList.contains('hidden')) {
        targetContentElement.classList.remove('hidden');
        targetContentElement.classList.add('flex');
      } else {
        targetContentElement.classList.add('hidden');
        targetContentElement.classList.remove('flex');
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const swiperProductImagesSelector = new Swiper('.swiper-product-images-selector', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 5, direction: 'horizontal', spaceBetween: 2 },
        768: { slidesPerView: 5, direction: 'vertical', spaceBetween: 4 },
      },
    });
    const swiperProductImagesDisplay = new Swiper('.swiper-product-images-display', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      thumbs: {
        swiper: swiperProductImagesSelector,
      },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
      },
      updateOnWindowResize: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
    });
    requestAnimationFrame(() => {
      swiperProductImagesDisplay.update();
    });
    const swiperFavDog = new Swiper('.swiper-fav-dog', {
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 16 },
      },
    });
    const swiperVetRecommendations = new Swiper('.swiper-vet-recommendations', {
      loop: true,
      // autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: { el: '.swiper-pagination-vet-recommendations', clickable: true },
    });

    const refreshKlaviyoCarouselSwiper = () => {
      const klaviyoRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
      if (!klaviyoRoot) return;

      const klaviyoSwipers = klaviyoRoot.querySelectorAll('.swiper');
      klaviyoSwipers.forEach((swiperElement) => {
        if (swiperElement.swiper) {
          swiperElement.swiper.update();
          swiperElement.swiper.updateSize();
          swiperElement.swiper.updateSlides();
        }
      });
    };

    const klaviyoCarouselRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
    if (klaviyoCarouselRoot) {
      const klaviyoCarouselObserver = new MutationObserver(() => {
        refreshKlaviyoCarouselSwiper();
      });

      klaviyoCarouselObserver.observe(klaviyoCarouselRoot, {
        childList: true,
        subtree: true,
      });

      window.addEventListener('resize', refreshKlaviyoCarouselSwiper);
      window.addEventListener('orientationchange', refreshKlaviyoCarouselSwiper);
      setTimeout(refreshKlaviyoCarouselSwiper, 300);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-dog-toppers-new"]) return;
  try {
    
  const productImages = document.querySelectorAll('[data-target-index]');
  let currentImage = document.getElementById('product-image-0');

  productImages.forEach((image) => {
    image.addEventListener('click', () => {
      const targetIndex = image.getAttribute('data-target-index');
      const targetImage = document.querySelector(targetIndex);
      currentImage.classList.add('hidden');
      targetImage.classList.remove('hidden');
      currentImage = targetImage;
    });
  });

  const productAccordion = document.querySelectorAll('[data-product-accordion-target]');
  productAccordion.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      const targetContent = accordion.getAttribute('data-product-accordion-target');
      const targetContentElement = document.querySelector(targetContent);
      if (targetContentElement.classList.contains('hidden')) {
        targetContentElement.classList.remove('hidden');
        targetContentElement.classList.add('flex');
      } else {
        targetContentElement.classList.add('hidden');
        targetContentElement.classList.remove('flex');
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const swiperProductImagesSelector = new Swiper('.swiper-product-images-selector', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 5, direction: 'horizontal', spaceBetween: 2 },
        768: { slidesPerView: 5, direction: 'vertical', spaceBetween: 4 },
      },
    });
    const swiperProductImagesDisplay = new Swiper('.swiper-product-images-display', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      thumbs: {
        swiper: swiperProductImagesSelector,
      },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
      },
      updateOnWindowResize: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
    });
    requestAnimationFrame(() => {
      swiperProductImagesDisplay.update();
    });
    const swiperFavDog = new Swiper('.swiper-fav-dog', {
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 16 },
      },
    });
    const swiperVetRecommendations = new Swiper('.swiper-vet-recommendations', {
      loop: true,
      // autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: { el: '.swiper-pagination-vet-recommendations', clickable: true },
    });

    const refreshKlaviyoCarouselSwiper = () => {
      const klaviyoRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
      if (!klaviyoRoot) return;

      const klaviyoSwipers = klaviyoRoot.querySelectorAll('.swiper');
      klaviyoSwipers.forEach((swiperElement) => {
        if (swiperElement.swiper) {
          swiperElement.swiper.update();
          swiperElement.swiper.updateSize();
          swiperElement.swiper.updateSlides();
        }
      });
    };

    const klaviyoCarouselRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
    if (klaviyoCarouselRoot) {
      const klaviyoCarouselObserver = new MutationObserver(() => {
        refreshKlaviyoCarouselSwiper();
      });

      klaviyoCarouselObserver.observe(klaviyoCarouselRoot, {
        childList: true,
        subtree: true,
      });

      window.addEventListener('resize', refreshKlaviyoCarouselSwiper);
      window.addEventListener('orientationchange', refreshKlaviyoCarouselSwiper);
      setTimeout(refreshKlaviyoCarouselSwiper, 300);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-dog-treats-new"]) return;
  try {
    
  const productImages = document.querySelectorAll('[data-target-index]');
  let currentImage = document.getElementById('product-image-0');

  productImages.forEach((image) => {
    image.addEventListener('click', () => {
      const targetIndex = image.getAttribute('data-target-index');
      const targetImage = document.querySelector(targetIndex);
      currentImage.classList.add('hidden');
      targetImage.classList.remove('hidden');
      currentImage = targetImage;
    });
  });

  const productAccordion = document.querySelectorAll('[data-product-accordion-target]');
  productAccordion.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      const targetContent = accordion.getAttribute('data-product-accordion-target');
      const targetContentElement = document.querySelector(targetContent);
      if (targetContentElement.classList.contains('hidden')) {
        targetContentElement.classList.remove('hidden');
        targetContentElement.classList.add('flex');
      } else {
        targetContentElement.classList.add('hidden');
        targetContentElement.classList.remove('flex');
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const swiperProductImagesSelector = new Swiper('.swiper-product-images-selector', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 5, direction: 'horizontal', spaceBetween: 2 },
        768: { slidesPerView: 5, direction: 'vertical', spaceBetween: 4 },
      },
    });
    const swiperProductImagesDisplay = new Swiper('.swiper-product-images-display', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      thumbs: {
        swiper: swiperProductImagesSelector,
      },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
      },
      updateOnWindowResize: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
    });
    requestAnimationFrame(() => {
      swiperProductImagesDisplay.update();
    });
    const swiperFavDog = new Swiper('.swiper-fav-dog', {
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 16 },
      },
    });
    const swiperVetRecommendations = new Swiper('.swiper-vet-recommendations', {
      loop: true,
      // autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: { el: '.swiper-pagination-vet-recommendations', clickable: true },
    });

    const refreshKlaviyoCarouselSwiper = () => {
      const klaviyoRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
      if (!klaviyoRoot) return;

      const klaviyoSwipers = klaviyoRoot.querySelectorAll('.swiper');
      klaviyoSwipers.forEach((swiperElement) => {
        if (swiperElement.swiper) {
          swiperElement.swiper.update();
          swiperElement.swiper.updateSize();
          swiperElement.swiper.updateSlides();
        }
      });
    };

    const klaviyoCarouselRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
    if (klaviyoCarouselRoot) {
      const klaviyoCarouselObserver = new MutationObserver(() => {
        refreshKlaviyoCarouselSwiper();
      });

      klaviyoCarouselObserver.observe(klaviyoCarouselRoot, {
        childList: true,
        subtree: true,
      });

      window.addEventListener('resize', refreshKlaviyoCarouselSwiper);
      window.addEventListener('orientationchange', refreshKlaviyoCarouselSwiper);
      setTimeout(refreshKlaviyoCarouselSwiper, 300);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-kibbles-new"]) return;
  try {
    
  const productImages = document.querySelectorAll('[data-target-index]');
  let currentImage = document.getElementById('product-image-0');

  productImages.forEach((image) => {
    image.addEventListener('click', () => {
      const targetIndex = image.getAttribute('data-target-index');
      const targetImage = document.querySelector(targetIndex);
      currentImage.classList.add('hidden');
      targetImage.classList.remove('hidden');
      currentImage = targetImage;
    });
  });

  const productAccordion = document.querySelectorAll('[data-product-accordion-target]');
  productAccordion.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      const targetContent = accordion.getAttribute('data-product-accordion-target');
      const targetContentElement = document.querySelector(targetContent);
      if (targetContentElement.classList.contains('hidden')) {
        targetContentElement.classList.remove('hidden');
        targetContentElement.classList.add('flex');
      } else {
        targetContentElement.classList.add('hidden');
        targetContentElement.classList.remove('flex');
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const swiperFavDog = new Swiper('.swiper-fav-dog', {
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 16 },
      },
    });
    const swiperVetRecommendations = new Swiper('.swiper-vet-recommendations', {
      loop: true,
      // autoplay: { delay: 2500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: { el: '.swiper-pagination-vet-recommendations', clickable: true },
    });

    const refreshKlaviyoCarouselSwiper = () => {
      const klaviyoRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
      if (!klaviyoRoot) return;

      const klaviyoSwipers = klaviyoRoot.querySelectorAll('.swiper');
      klaviyoSwipers.forEach((swiperElement) => {
        if (swiperElement.swiper) {
          swiperElement.swiper.update();
          swiperElement.swiper.updateSize();
          swiperElement.swiper.updateSlides();
        }
      });
    };

    const klaviyoCarouselRoot = document.querySelector('#klaviyo-featured-reviews-carousel');
    if (klaviyoCarouselRoot) {
      const klaviyoCarouselObserver = new MutationObserver(() => {
        refreshKlaviyoCarouselSwiper();
      });

      klaviyoCarouselObserver.observe(klaviyoCarouselRoot, {
        childList: true,
        subtree: true,
      });

      window.addEventListener('resize', refreshKlaviyoCarouselSwiper);
      window.addEventListener('orientationchange', refreshKlaviyoCarouselSwiper);
      setTimeout(refreshKlaviyoCarouselSwiper, 300);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-subscribe"]) return;
  try {
    
  const swiper = new Swiper('.swiper', {
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 2500,
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  } catch(e) { console.error(e); }
})();
})();
